import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const QuillEditorExtension = ({ name, value, onChange }) => {
  const handleChange = (content) => {
    if (content !== value) {
      onChange({
        target: {
          name,
          value: content,
        },
      });
    }
  };
  const customColors = [
    "#000000",
    "#e60000",
    "#ff9900",
    "#ffff00",
    "#008a00",
    "#0066cc",
    "#9933ff",
    "#ffffff",
    "#facccc",
    "#ffebcc",
    "#ffffcc",
    "#cce8cc",
    "#cce0f5",
    "#ebd6ff",
    "#f58baa",
    "#962fbf",
    "#F05D8A",
    "#dddddd",
    "#999999",
    "#6DCD5D",
    // Purples
    "#faf5ff",
    "#f3e8ff",
    "#e9d5ff",
    "#d8b4fe",
    "#c084fc",
    "#a855f7",
    "#9333ea",
    "#7e22ce",
    "#6b21a8",
    "#581c87",
    // Pinks
    "#fdf2f8",
    "#fce7f3",
    "#fbcfe8",
    "#f9a8d4",
    "#f472b6",
    "#ec4899",
    "#db2777",
    "#be185d",
    "#9d174d",
    "#831843",
  ];
  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ color: customColors }, { background: customColors }], // dropdown with defaults from theme
      [{ align: [] }],
      ["link", "image"],
      ["clean"],
    ],
  };

  return (
    <ReactQuill
      className="h-40 w-96 text-area"
      value={value}
      onChange={handleChange}
      modules={modules}
    />
  );
};

export default QuillEditorExtension;
